module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "titlepage"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("The Rare Coin Score")]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent",
    attrs: {
      "id": "tp01_p1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "extra-indent",
    attrs: {
      "id": "tp01_p2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "author",
    attrs: {
      "id": "tp01_p3"
    }
  }, [_vm._v("RICHARD STARK"), _c('br'), _c('br'), _c('i', [_vm._v("With a New Foreword by Luc Sante")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent",
    attrs: {
      "id": "tp01_p4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "publisher",
    attrs: {
      "id": "tp01_p5"
    }
  }, [_vm._v("The University of Chicago Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61957c81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titlepage.vue
// module id = 63
// module chunks = 0